export default {"src":"/_next/static/media/whatsapp-logo.92d52c04.svg","height":21,"width":22,"blurWidth":0,"blurHeight":0};